import { defineNuxtRouteMiddleware, navigateTo } from "nuxt/app";
import { getQueryParamValue } from "@chatfood/core-utils";
import { useBasketStore, useDirectBackend, useMenusStore } from "#imports";

export default defineNuxtRouteMiddleware(async (to) => {
  const QUERY_ID = "add-plu";

  const basketStore = useBasketStore();
  const plu = getQueryParamValue(to.query, QUERY_ID);

  if (!basketStore.isLoaded || !plu) {
    return;
  }

  const menusStore = useMenusStore();

  const { menuRepo } = useDirectBackend();

  try {
    const response = await menuRepo.getItems({
      plus: [plu],
      outletId: basketStore.outletId,
      menuIds: menusStore.menuIds,
    });

    const item = response.data[0];

    if (!item) {
      throw new Error("Item not found");
    }

    await basketStore.addItem({
      id: item.id,
      quantity: 1,
      unitPrice: item.price.value,
      notes: "",
      menuId: item.menuId,
      plu: item.plu,
      modifierLists: [],
    });
  } catch {
    // Knowing this is an user input which the system can't properly validate
    // the process will fail silently due to the many flaky reasons
    // like invalid plu, item not found in the outlet, item not available in the menu, etc
  }

  const cleanQuery = { ...to.query };
  delete cleanQuery[QUERY_ID];

  return navigateTo({
    ...to,
    query: cleanQuery,
    replace: true,
  });
});
